import { render, staticRenderFns } from "./TalkWs.vue?vue&type=template&id=7899e8e4&"
import script from "./TalkWs.vue?vue&type=script&lang=js&"
export * from "./TalkWs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports